import React from "react";
import BreadCrumb from "Common/BreadCrumb";
import TableWorkweInvoices from "./TableWorkweInvoices";

const BasicTable = () => {
  return (
    <React.Fragment>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb title="جبهه کاری" pageTitle="فاکتورها" />

        <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-1">
          <TableWorkweInvoices />
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicTable;
